import '@sass/destinations/destinations.scss';
import Destinations from '@/src/vue/components/Destinations/Destinations.vue';
import { createVueApp } from '@/src/vue/utils/createVueApp';

createVueApp(Destinations, { destinations: js_params.destinations2 }).mount('#destinations-vue');
